import { SagaIterator } from '@redux-saga/core';
import { all, takeLatest, put, call } from 'redux-saga/effects';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';

import * as Actions from './slice';
import * as Endpoints from './endpoints';

export function* fetchToken({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.fetchToken, payload);
    yield put(Actions.fetchTokenSuccess(response.data.token));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchTokenFailure(error));
  }
}

export function* LeadsManagementWatcherSaga(): SagaIterator {
  yield all([yield takeLatest(Actions.fetchToken.type, fetchToken)]);
}

export default LeadsManagementWatcherSaga;
